import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BackLink from "@/components/BackLink";
import PendingDraftBanner from "@/components/PendingDraftBanner";
import PostCreateGalleri from "@/components/PostCreateGalleri";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
function modHeaders() { return { Authorization: `Bearer ${sessionStorage.getItem("mod_token")}` }; }

export default function ModCreateTjanstekort() {
  const navigate = useNavigate();
  // Etappe 4.1 — defaulta andrad_av till inloggad användare
  const user = JSON.parse(sessionStorage.getItem("mod_user") || "null");
  const [form, setForm] = useState({ foretagsnamn: "", beskrivning: "", ort: "", kontaktperson: "", kontakt_telefon: "", kontakt_epost: "", webbplats: "", fraga_om_rut: false, fraga_om_rot: false, publish: true, andrad_av: (user?.name || user?.email || "").trim(), andringsnotering: "" });
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const [savedId, setSavedId] = useState(null); // Build 96.21

  const set = (f, v) => { setForm(p => ({ ...p, [f]: v })); if (errors[f]) setErrors(p => ({ ...p, [f]: null })); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!form.foretagsnamn.trim()) errs.foretagsnamn = "Ange företagsnamn";
    if (!form.beskrivning.trim()) errs.beskrivning = "Ange beskrivning";
    if (!form.kontakt_telefon.trim() && !form.kontakt_epost.trim()) errs.kontakt = "Ange minst telefon eller e-post";
    // Etappe 4.1 — Ändrad av Pflicht
    if (!form.andrad_av.trim()) errs.andrad_av = "Ange namn på den som ändrar posten innan du sparar.";
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    setBusy(true);
    try {
      const res = await axios.post(`${API}/mod/tjanstekort/create`, {
        foretagsnamn: form.foretagsnamn, beskrivning: form.beskrivning,
        ort: form.ort || null, kontaktperson: form.kontaktperson || null,
        kontakt_telefon: form.kontakt_telefon || null, kontakt_epost: form.kontakt_epost || null,
        webbplats: form.webbplats || null, fraga_om_rut: form.fraga_om_rut, fraga_om_rot: form.fraga_om_rot, publish: form.publish,
        andrad_av: form.andrad_av.trim(),
        andringsnotering: form.andringsnotering || null,
      }, { headers: modHeaders() });
      setSavedId(res.data.id); // Build 96.21
    } catch (err) { if (err.response?.status === 401) navigate("/mod/login"); else setErrors({ submit: err.response?.data?.detail || "Något gick fel" }); }
    setBusy(false);
  };

  if (savedId) {
    return (
      <div data-testid="mod-create-tjanstekort-success" className="max-w-2xl mx-auto px-4 sm:px-6 py-8">
        <BackLink to="/mod/praktiskt" label="Praktiskt i bygden" />
        <PostCreateGalleri
          collection="tjanstekort"
          itemId={savedId}
          titel={form.foretagsnamn}
          backTo="/mod/praktiskt"
          backLabel="Tillbaka till Praktiskt"
          publikt={form.publish}
        />
      </div>
    );
  }

  return (
    <div data-testid="mod-create-tjanstekort" className="max-w-2xl mx-auto px-4 sm:px-6 py-8">
      <BackLink to="/mod/praktiskt" label="Praktiskt i bygden" />
      <PendingDraftBanner urlPattern="/api/mod/tjanstekort" />
      <h1 className="font-heading text-2xl font-medium text-ink mb-6">Nytt tjänstekort</h1>
      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        <Field label="Företagsnamn" error={errors.foretagsnamn} required><input data-testid="tjanste-namn" value={form.foretagsnamn} onChange={e => set("foretagsnamn", e.target.value)} className="input-mod" /></Field>
        <Field label="Beskrivning" error={errors.beskrivning} required><textarea data-testid="tjanste-beskrivning" value={form.beskrivning} onChange={e => set("beskrivning", e.target.value)} rows={3} className="input-mod" /></Field>
        <Field label="Ort"><input value={form.ort} onChange={e => set("ort", e.target.value)} className="input-mod" placeholder="T.ex. Backe" /></Field>
        <Field label="Kontaktperson"><input value={form.kontaktperson} onChange={e => set("kontaktperson", e.target.value)} className="input-mod" /></Field>
        <Field label="Kontaktväg (minst en krävs)" error={errors.kontakt}>
          <input value={form.kontakt_telefon} onChange={e => set("kontakt_telefon", e.target.value)} className="input-mod mb-2" placeholder="Telefon" />
          <input value={form.kontakt_epost} onChange={e => set("kontakt_epost", e.target.value)} className="input-mod" placeholder="E-post" />
        </Field>
        <Field label="Webbplats"><input value={form.webbplats} onChange={e => set("webbplats", e.target.value)} className="input-mod" placeholder="https://..." /></Field>
        {/* Etappe 4.1 — Pflicht-Audit-Felder */}
        <Field label="Ändrad av" error={errors.andrad_av} required>
          <input data-testid="tjanste-andrad-av" value={form.andrad_av} onChange={e => set("andrad_av", e.target.value)} className="input-mod" placeholder="Ange namn på den som ändrar posten" />
        </Field>
        <Field label="Ändringsnotering (valfritt)">
          <input value={form.andringsnotering} onChange={e => set("andringsnotering", e.target.value)} className="input-mod" placeholder="Kort kommentar om vad som ändrades" />
        </Field>
        <div className="flex gap-6">
          <label className="flex items-center gap-2 text-base"><input type="checkbox" checked={form.fraga_om_rut} onChange={e => set("fraga_om_rut", e.target.checked)} className="w-5 h-5 accent-pine" /> Fråga om RUT</label>
          <label className="flex items-center gap-2 text-base"><input type="checkbox" checked={form.fraga_om_rot} onChange={e => set("fraga_om_rot", e.target.checked)} className="w-5 h-5 accent-pine" /> Fråga om ROT</label>
        </div>
        <div className="flex items-center gap-3"><input type="checkbox" checked={form.publish} onChange={e => set("publish", e.target.checked)} className="w-5 h-5 accent-pine" /><label className="text-base text-ink">Publicera direkt</label></div>
        {errors.submit && <p className="text-falu">{errors.submit}</p>}
        <button type="submit" disabled={busy} data-testid="tjanste-submit" className="bg-pine hover:bg-pine-hover text-white font-medium px-6 py-3 rounded-md text-base transition-colors disabled:opacity-50 w-fit">{busy ? "Sparar..." : "Skapa"}</button>
      </form>
    </div>
  );
}

function Field({ label, error, required, children }) {
  return (<div><label className="block text-sm font-medium text-ink mb-1">{label}{required && <span className="text-falu ml-1">*</span>}</label>{children}{error && <p className="text-falu text-sm mt-1">{error}</p>}</div>);
}
